import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUnlinkIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.66683 10.3335L10.3335 5.66681M6.00016 2.66683V1.3335M10.0002 13.3335V14.6668M2.66683 6.00016H1.3335M13.3335 10.0002H14.6668M3.27631 3.27631L2.3335 2.3335M12.724 12.724L13.6668 13.6668M8.00019 11.7713L6.58597 13.1856C5.54457 14.227 3.85613 14.227 2.81474 13.1856C1.77334 12.1442 1.77334 10.4557 2.81474 9.41432L4.22895 8.0001M11.7714 8.0001L13.1856 6.58589C14.227 5.54449 14.227 3.85605 13.1856 2.81465C12.1442 1.77326 10.4558 1.77326 9.4144 2.81465L8.00019 4.22887",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgUnlinkIcon;
